
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/challenge",
      function () {
        return require("private-next-pages/challenge.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/challenge"])
      });
    }
  